import { createFileRoute } from "@tanstack/react-router";
import { SessionDetail } from "@/features/sessions";

/**
 * THE SESSION YOU PICKED — pushed from the deck, one segment deeper, so the shell plays the
 * stack transition rather than a cross-fade (`navDirection` in `src/app/lib/motion.ts` reads
 * path depth).
 *
 * ⚠️ WHY `.index` AND NOT `_app.session.$id.tsx`, which is what the issue writes.
 *
 * Strength, timer and debrief are pushed screens in their own right, not panels inside this
 * one. If this screen owned the file at `/session/$id`, TanStack Router would treat it as
 * their LAYOUT — its heading and body would render above all three, and only if it also
 * rendered an `<Outlet />`, which is not what "pushed" means. Taking the index position
 * instead leaves `/session/$id` addressing exactly this screen and the three siblings
 * addressing themselves.
 *
 * ⚠️ NO `<h1>` HERE ANY MORE. The design gives this screen its own 52px header bar carrying
 * the ✕, the title and the RX tag, and that bar is part of the screen rather than of the
 * route — a second heading above it would be the title printed twice.
 */
export const Route = createFileRoute("/_app/session/$id/")({
  component: SessionScreen,
});

function SessionScreen() {
  const { id } = Route.useParams();

  return <SessionDetail sessionId={id} />;
}
